import { useState, useEffect } from 'react';
import { useStore } from 'zustand';

import { BottomPanel } from '@/view/ui/battle/BottomPanel/BottomPanel';
import { LeatherBox, PergamentBox } from '@/view/ui/common/NineSliceBox';
import { BattleStatus } from '@/core/types/battle.types';
import { GameScene } from '@/core/types/global.types';
import { useBattleStore } from '@/store/useBattleStore';
import { useGlobalStore } from '@/store/useGlobalStore';
import { PauseMenu } from '@/view/ui/battle/PauseMenu';
import { pauseToggle } from '@/core/utils/battle.utils';
import { BattleResultScreen } from '@/view/ui/battle/BattleResultScreen';

export const BattleUI = () => {
    const { status } = useStore(useBattleStore);
    const setScene = useGlobalStore(s => s.setScene);
    const battleStore = useBattleStore();

    // Стан саме для кнопки виходу
    const [showExitButton, setShowExitButton] = useState(false);

    useEffect(() => {
        if (status === BattleStatus.Victory || status === BattleStatus.Defeat) {
            // Затримка ТІЛЬКИ для фіналу
            const timer = setTimeout(() => setShowExitButton(true), 1000);
            return () => clearTimeout(timer);
        } else {
            // Якщо бій іде або тільки почався — скидаємо стан кнопки
            setShowExitButton(false);
        }
    }, [status]);

    const handleResume = () => {
        pauseToggle(battleStore);
    };

    // --- 1. ЛОГІКА ЗАВЕРШЕННЯ БОЮ ---
    if (status === BattleStatus.Victory || status === BattleStatus.Defeat) {
        return (<>
            <div className="ui-full-overlay">
                {showExitButton && (
                    <BattleResultScreen/>
                )}
                
            </div>
            <div className="bottom-panel-container">
                <div className="bottom-panel">
                </div>
            </div>
        </>
        );
    }
    const isPaused = status === BattleStatus.Paused;
    // --- 2. ЛОГІКА ПІД ЧАС БОЮ (Миттєва) ---
    if (status !== BattleStatus.Playing && status !== BattleStatus.Preparing && status !== BattleStatus.Paused) return null;
    if (status === BattleStatus.Preparing) return <div className="bottom-panel-container" style={{border: 'none'}}></div>;
    return (<>
        <div 
          onClick={handleResume}
          className={`
            ui-full-overlay h-[calc(100dvh-100px)]
            transition-opacity duration-300
            ${isPaused ? 'opacity-100 pointer-events-auto' : 'opacity-0 pointer-events-none'}
        `}>{isPaused && <PauseMenu onClose={handleResume}/>}</div>
        <div className="bottom-panel-container" onClick={isPaused ? handleResume : undefined}>
            <BottomPanel />
        </div></>
    );
};